type LeaseVariant = 'standard' | 'kcpoa'

export const isValidRenewalTerm = (term: number, leaseVariant: LeaseVariant) =>
  Number.isInteger(term) && term >= (leaseVariant === 'kcpoa' ? 3 : 1)

export const isValidCustomRenewalTerm = (term: number) => Number.isInteger(term) && term >= 2

export const calculateRenewalTermFromDates = (startDate: Date, endDate: Date | null) => {
  if (!endDate || endDate <= startDate) return Number.NaN

  const calendarMonths =
    (endDate.getFullYear() - startDate.getFullYear()) * 12 +
    endDate.getMonth() -
    startDate.getMonth()

  // Renewal dates are inclusive, so any partial calendar month counts as a month.
  return Math.max(1, calendarMonths + (endDate.getDate() >= startDate.getDate() ? 1 : 0))
}

export const isValidRenewalRent = (rent: number) => Number.isFinite(rent) && rent > 0

export const isValidRenewalOptionPremium = (optionPremium: number) =>
  Number.isFinite(optionPremium) && optionPremium >= 0
